/**
 * ページ以外の一覧用の便利関数
 * @extends list
 */
import mixinList from './list'

export default {
  mixins: [ mixinList ],
  data () {
    return {
      useStoreConds: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/innerList.js